import React from 'react';
import GenericErrorUI from '../../../components/common/GenericErrorUI';
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI';
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI';
import IconButtonUI from '../../../widgets/action/IconButtonUI';
import EmptyListUI from '../../../widgets/output/EmptyListUI';
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI';
import CardUI from '../../../widgets/layout/CardUI';

const SalesReportListPageUI = ({ context, errorList, salesReportList, onRefreshClick }) => (
  <SuperUserHomePageUI
    context={context} className='pg_su_ld' topnav='accounts'
    centered={!salesReportList && !errorList} page='salesReport'
  >
    {
      (!salesReportList && !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }

    {
      salesReportList && <LRTableActionsUI
        location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <span className='g_m_left_100 g_large'><b>Sales Reports</b></span>
          </span>
        }
        right={<span />}
      />
    }
    {
      salesReportList && salesReportList.length === 0 && (
        <EmptyListUI context={context} createEnabled={false} createDisabledMessageLabel='No Sales Reports' />
      )
    }
    {
      salesReportList && salesReportList.length > 0 && (
        <div>

          <CardUI>
            <table>
              <thead>
                <tr>
                  <th className='g_p_right_100'>First Name</th>
                  <th className='g_p_left_100'>Last Name</th>
                  <th className='g_p_left_100'>Year</th>
                  <th className='g_p_left_100'>Month</th>
                  <th className='g_p_left_100'>Lead Name</th>
                  <th className=''>Channel</th>
                </tr>
              </thead>
              <tbody>
                {salesReportList.map((salesReport, index) => (
                  <tr key={index}>
                    <td>{salesReport.firstName}</td>
                    <td className='g_p_left_100'>{salesReport.lastName}</td>
                    <td className='g_text_right'>{salesReport.year}</td>
                    <td className='g_p_left_100'>{salesReport.monthName}</td>
                    <td className='g_p_left_100'>{salesReport.leadName}</td>
                    <td className='g_p_left_100'>{salesReport.channel}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </CardUI>
        </div>
      )
    }

  </SuperUserHomePageUI>
);

export default SalesReportListPageUI;
